@if (view.site && view.site.profile && view.site.profile.sections) {
    @switch (view.site.profile.sections.banner) {
        @case (1) {
            <banner-type01></banner-type01>
            }
        @case (2) {
            <banner-type02></banner-type02>
            }
        @case (3) {
            <banner-type03></banner-type03>
            }
        @case (4) {
            <banner-type04></banner-type04>
            }
        @case (5) {
            <banner-type05></banner-type05>
            }
        @case (6) {
            <banner-type06></banner-type06>
            }
    }
}

<!-- <app-slide-up-popup [isVisible]="view.isPopupVisible" (closed)="onPopupClosed()">
  <h2 class="text-xl font-semibold">Welcome!</h2>
  <p class="text-gray-600">This popup appeared automatically after 3 seconds.</p>
</app-slide-up-popup> -->

@if (view.site && view.site.profile && view.site.profile.sections) {
    @switch (view.site.profile.sections.changeGame) {
        @case (1) {
            <div class="mt-20 md:mt-44">
                <app-xl-leisure-travel [isLandingPage]="true"></app-xl-leisure-travel>
            </div>
            <!-- <app-change-game-type01 [features]="view.features"></app-change-game-type01> -->
            }
        @case (2) {
        }
        @case (3) {
            }
    }
}

<!-- Custom Heading Section -->
 @if(view.site?.id === 74) {
     <div class="mt-16 md:mt-24">
        <app-heading_section-type02></app-heading_section-type02>
     </div>
 }

<!-- Service Section (site 11 renders above testimonials instead) -->
@if (view.site && view.site.profile && view.site.profile.sections && view.site?.id !== 11) {
    @switch (view.site.profile.sections.services) {
        @case (1) {
            <!-- Banner type 5: search widget is absolutely positioned and overlaps the next section — need top margin when searchwidget is on -->
            <div [ngClass]="view.site?.id === 77 ? 'mt-12 md:mt-8' : (view.site?.profile?.sections?.searchwidget ? (view.site?.profile?.sections?.banner === 5 ? 'mt-[5.5rem] md:mt-28 lg:mt-32 xl:mt-36' : 'mt-32 md:mt-40 lg:mt-48') : '')">
                <app-services-type01></app-services-type01>
            </div>
            }
        @case (2) {
            <app-services-type02></app-services-type02>
            }
        @case (3) {
            <app-services-type03></app-services-type03>
            }
    }
}

<!-- Deals Section (SPECIALS) – when site has no service section, use extra top margin so deals sit lower -->
@if (view.site && view.site.profile && view.site.profile.sections) {
    @switch (view.site.profile.sections.deals) {
        @case (1) {
            <div [ngClass]="dealsSectionMarginClass">
                <app-deals-type01 [isLandingPage]="true"></app-deals-type01>
            </div>
            }
        @case (2) {
            <app-deals-type02></app-deals-type02>
            }
        @case (3) {
            <app-deals-type03></app-deals-type03>
            }
    }
}

<!-- Destination List Section (PACKAGES) -->
@if (view.site && view.site.profile && view.site.profile.sections) {
    @switch (view.site.profile.sections.destination_list) {
        @case (1) {
            <app-destination-list-type01 id="destination-section"></app-destination-list-type01>
            }
        @case (2) {
            <app-destination-list-type02 id="destination-section"></app-destination-list-type02>
            }
    }
}

<!-- Slide Banner Section -->
@if (view.site?.profile?.sections) {
    @switch (view.site.profile.sections.blackfriday) {
        @case (1) {
            <app-slide-banner-type01></app-slide-banner-type01>
        }
    }
}

<!-- Why Us? -->
@if (view.site && view.site.profile && view.site.profile.sections) {
    @switch (view.site.profile.sections.why_us ) {
        @case (1) {
            <app-why_us-type01></app-why_us-type01>
        }
        @case (2) {
            <app-why_us-type02 title="XL Members" heading="" tagline="Membership base of 150 prominent travel agencies spread across Southern Africa" tagline2="and growing!!" 
                text="Members of the XL Group are therefore able to extend a wide range of cost-saving benefits to their clientele through some 900 highly trained travel counselors."
                [options]="{showMap:true}" [url]="{href:'/branches', text:'View Our Members'}"></app-why_us-type02>
        }
        @case (3) {
            <app-why_us-type03 class="px-4"></app-why_us-type03>
        }
        @case (4) {
            <app-why_us-type04 class=""></app-why_us-type04>
        }
        @case (5) {
            <app-why_us-type05 class=""></app-why_us-type05>
        }
    }
}

<!-- Logo scroller -->
@if (view.site && view.site.profile && view.site.profile.sections) {
    @switch (view.site.profile.sections.scroller ) {
        @case (1) {
            <app-scroller_section-type01></app-scroller_section-type01>
        }
    }
}

<!-- Flight Deals -->
@if (view.site && view.site.profile && view.site.profile.sections) {
    @switch (view.site.profile.sections.flight_deals ) {
        @case (1) {
            <app-flight_deals-type01></app-flight_deals-type01>
        }
    }
}

<!-- Travel Deals -->
@if (view.site && view.site.profile && view.site.profile.sections) {
    @switch (view.site.profile.sections.travel_deals ) {
        @case (1) {
            <app-travel_deals-type01></app-travel_deals-type01>
        }
    }
}

<!-- Popular Hotels -->
@if (view.site && view.site.profile && view.site.profile.sections) {
    @switch (view.site.profile.sections.popular_hotels ) {
        @case (1) {
            <app-popular_hotels-type01></app-popular_hotels-type01>
        }
    }
}

<!-- @if(view.site?.id === 63) {
<div class="w-full bg-white py-8 px-8">
    <h2 class="text-center text-3xl md:text-4xl font-extrabold text-gray-800 tracking-tight leading-snug mb-10">
        Promotions
    </h2>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 place-items-center">

        <img src="/assets/images/xl-travel-banners/UA_ISD_10423_ZA_BannerResize_A_R1.jpg" alt="Image 1"
        class="w-full rounded-lg shadow-lg cursor-pointer transition-transform duration-300 hover:scale-105"
        (click)="handleBannerClick('banner-01')"
        />
        <img src="/assets/images/xl-travel-banners/UA_ISD_10423_ZA_BannerResize_B_R1.jpg" alt="Image 1"
        class="w-full rounded-lg shadow-lg cursor-pointer transition-transform duration-300 hover:scale-105"
        (click)="handleBannerClick('banner-02')"
        />
        <img src="/assets/images/xl-travel-banners/UA_ISD_10423_ZA_BannerResize_C_R1.jpg" alt="Image 1"
        class="w-full rounded-lg shadow-lg cursor-pointer transition-transform duration-300 hover:scale-105"
        (click)="handleBannerClick('banner-03')"
        />
        <img src="/assets/images/xl-travel-banners/UA_ISD_10423_ZA_BannerResize_D_R1.jpg" alt="Image 1"
        class="w-full rounded-lg shadow-lg cursor-pointer transition-transform duration-300 hover:scale-105"
        (click)="handleBannerClick('banner-04')"
        />

    </div>
</div>
} -->

<!-- Service Section (site 11: directly above testimonials) -->
@if (view.site && view.site.profile && view.site.profile.sections && view.site?.id === 11) {
    @switch (view.site.profile.sections.services) {
        @case (1) {
            <div class="mt-0">
                <app-services-type01></app-services-type01>
            </div>
            }
        @case (2) {
            <app-services-type02></app-services-type02>
            }
        @case (3) {
            <app-services-type03></app-services-type03>
            }
    }
}

<!-- Testimonials -->
@if (view.site && view.site.profile && view.site.profile.sections) {
    @switch (view.site.profile.sections.testimonial) {
        @case (1) {
            <app-testimonial-type01></app-testimonial-type01>
            }
        @case (2) {
            <app-testimonial-type02></app-testimonial-type02>
            }
        @case (3) {
            <app-testimonial-type03></app-testimonial-type03>
            }
        @case (4) {
            <app-testimonial-type04></app-testimonial-type04>
        }
    }
}

<!-- Articles -->
@if (view.site && view.site.profile && view.site.profile.sections) {
    @switch (view.site.profile.sections.articles ) {
        @case (1) {
            <articles-type01></articles-type01>
        }
        @case (2) {
            <articles-type02></articles-type02>
        }
        @case (3) {
            <articles-type03></articles-type03>
        }
        @case (4) {
            <articles-type04></articles-type04>
        }
    }
}

<!-- Newsletters -->
@if (view.site && view.site.profile && view.site.profile.sections) {
    @switch (view.site.profile.sections.newsletters) {
        @case (1) {
            <app-newsletters-type01></app-newsletters-type01>
            }
        @case (2) {
            <app-newsletters-type02></app-newsletters-type02>
            }
        @case (3) {
            <app-newsletters-type03  [clientId]="'f70d270c0e8211e58476736572766572'"
            [formId]="'c8ea717070a111e8bcc9736572766572'"
            integration="bar"
            buttonText=""
            buttonId="">
            </app-newsletters-type03>
        }
    }
}

<!-- Counters -->
@if (view.site && view.site.profile && view.site.profile.sections) {
    @switch (view.site.profile.sections.counter) {
        @case (1) {
            <app-counters-type01></app-counters-type01>
        }
    }
}


